import { FC, useState, useEffect } from "react";
import Header from "../SubComponents/Header";
import Hero from "../SubComponents/Hero";
import Community from "../SubComponents/Community";
import Projects from "../SubComponents/Projects";
import Slider from "../SubComponents/Slider";
import Cta from "../SubComponents/CTA";
import Footer from "../SubComponents/Footer";
import HomeFaq from "../SubComponents/HomeFAQ";
import KycSection from "../SubComponents/KycSection";
import { Box } from "@material-ui/core";
import Banner from "../SubComponents/LandingBanner/Banner";
import { appConfig } from "../../config";


const Home: FC = () => {

  const displayBanner = appConfig.displayStakingAd;
  const [openBanner, setOpenBanner] = useState(false);

  useEffect(() => {
    // Open the banner when the page loads
    if (displayBanner) setOpenBanner(true);
  }, []);

  const handleBannerClose = () => {
    setOpenBanner(false);
  };

  const handleBannerButtonClick = () => {
    // Handle button click inside the banner
    console.log("Stake Now button clicked");
    setOpenBanner(false); // Optionally close the banner after the click
  };

  return (
    <Box className="aspekta-regular" style={{ overflow: "hidden" }}>
      <Header timer={true} />
      <Hero />
      <Community />
      <Projects />
      <Slider />
      <KycSection />
      <HomeFaq />
      <Cta />
      <Footer />
      
      {/* Render the Banner as a Dialog */}
      <Banner
        open={openBanner}
        onClose={handleBannerClose}
        onButtonClick={handleBannerButtonClick}
      />
    </Box>
  );
};

export default Home;